export default __webpack_public_path__ + "static/media/GR00061-plan_arrow.2fb5c08b.svg";